export default
{
	availableUnits: 10,
	score: {
		min: 4,
		max: 8,
        displayMax: 10
	},
	name: "delier1",
	day: 1,
	date: {
		time: "09:33",
		day: "scene.date.text"
	},
	patientState: 0,
	delirium: {
		initialState: "oranje",
		initialScore: 5,
		clockPosition: {
			x: 786,
			y: 185
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier1/${locale}/delier_1_nacht_ochtend_blinds-dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier1/${locale}/delier_1_nacht_ochtend_blinds-dicht_ma.flv"
			}
		],
		roomViewToggleButtonPosition: {
			x: 1010,
			y: 372
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier1/delier1_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier1/delier1_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier1/delier1_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier1/delier1_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 782,
			y: 189
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier1/${locale}/delier_1_slot_blinds_dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier1/${locale}/delier_1_slot_blinds_dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier1/${locale}/delier_1_slot_blinds_dicht_di.flv"
			},
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier1/${locale}/delier_1_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier1/${locale}/delier_1_slot_blinds_open_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 1,
				url: "delier1/${locale}/delier_1_slot_blinds_open_di.flv"
			}
		]
	},
	transitions: [
		{
			deliriumState: "groen",
			target: "delier2"
		},
		{
			deliriumState: "oranje",
			target: "delier3"
		},
		{
			deliriumState: "rood",
			target: "delier4"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier1/${locale}/delier_1_dialoog_start.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientwijzenoprealiteit",
			value: "delier1/${locale}/delier_1_dialoog_ontkennen.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "meegaaninhallucinatievanpatient",
			value: "delier1/${locale}/delier_1_dialoog_oplossen.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier1/${locale}/delier_1_dialoog_dag.flv"
		}
	]
}